<template>
    <div class="loginStyle">
        <!-- 企业微信登录入口 -->
        <div class="ab login_img_box">
            <img src="../assets/img/T250310_1.png" style="width: 380px;" alt="">
            <p class="link_p">让每一个连接更具价值</p>
            <img src="../assets/img/waitting.png" style="width: 216px;" alt="加载中···">
        </div>
    </div>
</template>
<script>    
var axios = require('axios')
export default {
    name:'WXLogin',
    data() {
        return {};
    },
    mounted(){
        let codes = this.$common.getParams(window.location.href).code;
        if(codes){
            // 联合登录跳转
            axios({
                method: 'get',
                url: this.API.Sso + `admin/enterprise/wechat/signIn/${codes}`,
                headers: {'Accept-Language': 'zh-CN'}
            })
            .then(res => {
                if(res.data.code == 200){
                    let { systems, token } = res.data.data;
                    document.cookie = "JointLogin="+ token +";path=/;"
                    let arr = systems.map(ele => ({sysCode:ele.sysCode}));
                    document.cookie = "JointParams="+ JSON.stringify(arr) +";path=/;"
                    this.$router.replace('/login'); //跳转页面
                }else{
                    // 清除cookie
                    this.$message.error('登录失败，请重新点击进入');
                }
            }).catch(err => {
                // 清除cookie
                // this.resetToken();
            })
        }
        
    }
};
</script>
<style scoped>
    .loginStyle{
        height: 100%;
        display: flex;
        background: #1c1c1c;
    }
    .loginleft{
        width: 400px;
        border-radius: 8px 0px 0px 8px;
        overflow: hidden;
    }
    .Left_top{
        height: 78px;
        line-height: 78px;
        font-size: 18px;
        color:#8E96A2;
    }
    .loginRight{
        position: relative;
    }
    .loginRight_div{
        width: 430px;
        position: absolute;
        top:42%;
        left: 50%;
        transform: translate(50%,-50%);
    }
    .logo_img_ico{
        width:20px;
        height:20px;
        padding-top:1px;
    }
    .re{
        position: relative;
    }
    .ab{
        position: absolute;
    }
    .cursors{
        cursor: pointer;
    }
    li{
        list-style: none;
        border: 1px solid #e9e9e9;
        padding: 14px 12px;
        margin-bottom: 6px;
        border-radius: 5px;
        display: flex;
        align-items: center;
        color: #333;
        justify-content: space-between;
    }
    li:hover{
        border-color: #007dff;
        color: #3e92eb;
        background: #c4d9ff33;
    }
    .item_cont{
        width:14px;
        height:14px;
        padding:11px 0px 0px 3px;
    }
    .code_items{
        display:inline-block;
        width:130px; 
        height:34px;
        border:1px solid #cdcdcd;
        border-radius:3px;
        overflow:hidden;
        right:0px;
    }
    .item_btns{
        font-size:18px;
        width:100%;
    }
    .link_p{
        color: #c4c48b;
        font-size: 16px;
        text-align: center;
        padding-top: 5px;
        margin: 0px 0px 58px;
        font-weight: 500;
    }
    .tips_con{
        position:fixed;
        bottom: 12px;
        font-size:16px;
        color:#837643;
        left: 46%;
    }
    .login_img_div{
        width:700px;
        text-align: center;
        background: #1c1c1c;
        border-radius: 0px 19px 19px 0px;
        overflow: hidden;
    }
    .login_img_box{
        width:700px;
        text-align: center;
        top:36%;
        left: 50%;
        transform: translate(-50%,-50%);
    }
    .loginRight_H2{
        text-align: center;
        margin-bottom: 0px;
        font-size: 26px;
        color: #000;
    }
    .loginRight_Tips{
        text-align: center;
        margin-bottom: 36px;
        color:#777;
        font-size: 13px;
        margin-top: 3px;
    }
    .out_P{
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 0px;
    }
</style>
<style>
.el-steps--simple{
    background: none;
}
.el-step.is-simple .el-step__title{
    font-size: 18px;
}
</style>


// WEBPACK FOOTER //
// src/login/WXLogin.vue